<script>
  // Risk-score donut. Adapted from the sales-target ring in routes/Home.svelte,
  // with a UNIQUE gradient id ('crScoreGradient') so the two never collide when
  // co-mounted. riskScore is 0=worst..100=best, so a fuller ring is better.
  export let score = null;
  export let size = 96;

  $: pct = typeof score === 'number' && Number.isFinite(score)
    ? Math.max(0, Math.min(score, 100))
    : null;
</script>

<div class="relative shrink-0" style="width: {size}px; height: {size}px;">
  <svg class="w-full h-full transform -rotate-90" viewBox="0 0 36 36" aria-hidden="true">
    <circle cx="18" cy="18" r="16" fill="none" stroke="currentColor" stroke-width="3" class="text-gray-200 dark:text-gray-700" />
    {#if pct !== null}
      <circle
        cx="18" cy="18" r="16" fill="none" stroke="url(#crScoreGradient)" stroke-width="3" stroke-linecap="square"
        stroke-dasharray="{pct * 1.005} 100.5"
      />
    {/if}
    <defs>
      <linearGradient id="crScoreGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stop-color="#00f0ff" />
        <stop offset="100%" stop-color="#ff00ff" />
      </linearGradient>
    </defs>
  </svg>
  <div class="absolute inset-0 flex flex-col items-center justify-center leading-none">
    <span class="font-display crt-glow text-2xl font-bold text-gray-900 dark:text-white">{pct !== null ? pct : '—'}</span>
    {#if pct !== null}<span class="text-[10px] text-gray-400 mt-0.5">/100</span>{/if}
  </div>
</div>
